import { useState } from "react";

import { cn } from "../lib/util.js";

const STARS = [1, 2, 3, 4, 5];

/* 별점 입력. Stars.jsx 와 달리 여기는 겹쳐 그리지 않는다 — 별 하나하나가
   눌러야 하는 과녁이라 제 영역을 가진 버튼이어야 한다(표시용은 클릭 대상이 아니다).

   토글 컴포넌트를 쓰지 않은 이유: 별점은 칸 다섯 개가 서로를 켜고 끄는 게 아니라
   '몇 번째까지 채우는가'다. 눌린 칸만 강조하는 토글의 data-[state=on] 스타일과
   싸우게 되고, 그걸 전부 무력화하면 남는 게 없다.

   hover·focus 중에는 그 별까지 미리 채워 보여준다. 누르기 전에 몇 점이 될지
   모르면 다섯 개 중 하나를 정확히 겨냥할 수가 없다. */
export function RatingInput({ value, onChange, className }) {
  const [preview, setPreview] = useState(0);
  const shown = preview || value || 0;

  return (
    <div
      role="radiogroup"
      aria-label="별점"
      className={cn("rating-input flex items-center gap-1", className)}
      onMouseLeave={() => setPreview(0)}
    >
      {STARS.map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          data-star={n}
          aria-checked={value === n}
          aria-label={`${n}점`}
          className={cn(
            "star px-px text-[27px] leading-none transition-colors",
            n <= shown ? "text-star" : "text-input",
          )}
          onMouseEnter={() => setPreview(n)}
          onFocus={() => setPreview(n)}
          onBlur={() => setPreview(0)}
          onClick={() => onChange(n)}
        >
          ★
        </button>
      ))}
      <span className="ml-1.5 text-[15px] font-bold text-foreground">
        {shown.toFixed(1)}
      </span>
    </div>
  );
}
